const config = {
  uri: import.meta.env.VITE_API_URL,
  ws: import.meta.env.VITE_API_WS_URL,
};

export default config;
